'use strict'

import {
  startPortalLoadingTask
} from './portal-loading-widget.js'
import {
  installLeafletDrawDualDashPreview
} from './portal-dual-dash.js'

const bindWaypointToolsHandlers = function ({
  _ = window._,
  $ = window.jQuery,
  L = window.L,
  $body = ($ ? $('body') : null),
  Swal = window.Swal,
  areaSwal = Swal,
  fnT = function (key) { return String(key || '') },
  state = {},
  DEM_PROVIDER_PRIORITY = [],
  POINT_HEIGHT_PATH_ALIASES = [],
  POINT_EXECUTE_HEIGHT_PATH_ALIASES = [],
  NON_EXPORT_POINT_HEIGHT_PATH = 'project.height',
  roundToTenth = function (value) { return Number(value) },
  toFiniteNumber = function (value) { const n = Number(value); return Number.isFinite(n) ? n : null },
  fnSyncAddPointCursor = function () {},
  fnSetWaypointDragging = function () {},
  fnSelectAllPoints = function () {},
  fnSelectClear = function () {},
  fnBuildDividePointsPopupHtml = function () { return '' },
  fnIsDemProviderEnabled = function () { return true },
  fnGetDemProviderLabel = function (key) { return String(key || '') },
  fnCaptureState = function () { return null },
  fnGetPointName = function () { return '' },
  fnRemovePointXmlNodes = function () {},
  fnSyncMissionPlacemarkOrder = function () {},
  fnRenderImportLines = function () {},
  fnHistoryPush = function () {},
  fnGetPointHeading = function () { return null },
  fnGetFirstNumericFromPointXmlTags = function () { return null },
  fnGetPointRawHeightValue = function () { return null },
  fnRoundLetter = function (idx) {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const n = Number.isFinite(Number(idx)) ? Number(idx) : 0
    const mod = ((n % alphabet.length) + alphabet.length) % alphabet.length
    return alphabet.charAt(mod)
  },
  fnCreateInsertedPoint = function () { return null },
  fnSetByPath = function () {},
  fnSetPointValueByPathAliases = function () {},
  fnSetPointDemValue = function () {},
  fnBuildDivideRenameRowsFromCreatedPoints = function () { return [] },
  fnApplyDivideRowNames = function () {},
  fnFetchSurfaceElevationByProvider = async function () { return [] },
  fnSwalBulkEdit = function () {}
} = {}) {
  const map = state.map || null
  const fnIsLocalProviderActive = function () {
    if (typeof window === 'undefined') return false
    const localState = window.PORTAL_LOCAL_TERRAIN_STATE
    return !!(
      localState &&
      localState.active === true &&
      (
        typeof localState.sampleElevation === 'function' ||
        typeof localState.sampleElevationAsync === 'function' ||
        typeof localState.sampleElevations === 'function'
      )
    )
  }
  const fnIsProviderAvailable = function (providerKey) {
    const key = String(providerKey || '').trim()
    if (!key) return false
    if (key === 'localDEM') return fnIsLocalProviderActive()
    return fnIsDemProviderEnabled(key)
  }
  const fnBuildEffectiveDemProviderKeys = function () {
    const out = fnIsLocalProviderActive() ? ['localDEM'] : []
    DEM_PROVIDER_PRIORITY.forEach((providerKey) => {
      const key = String(providerKey || '').trim()
      if (!key || out.includes(key)) return
      out.push(key)
    })
    return out
  }
  const fnYieldToUi = function () {
    return new Promise((resolve) => {
      if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function () {
          resolve()
        })
        return
      }
      setTimeout(resolve, 0)
    })
  }

  if (!$body || typeof $body.find !== 'function') return
  if ($body.data('waypointToolsHandlersBound')) return
  $body.data('waypointToolsHandlersBound', true)

$body.find('[data-leaf-select-poly]').on('click', function () {
  state.importSelectMode = true
  state.importAddPointMode = false
  fnSyncAddPointCursor()
  $body.find('[data-leaf-select-poly]').addClass('active')
  $body.find('[data-leaf-select-square]').removeClass('active')
  $body.find('[data-leaf-add-point]').removeClass('active')
  if (!state.importSelectDrawPoly) {
    state.importSelectDrawPoly = new L.Draw.Polygon(map, {
      allowIntersection: false,
      showArea: true,
      shapeOptions: {
        color: '#ffffff',
        weight: 2,
        dashArray: '4,4',
        fillOpacity: 0.05
      }
    })
  }
  state.importSelectDrawPoly.enable()
  installLeafletDrawDualDashPreview({
    L: L,
    map: map,
    drawLayer: state.importSelectDrawPoly
  })
})

$body.find('[data-leaf-select-all]').on('click', function () {
  const points = (state.importMissionState && state.importMissionState.waypoints) ? state.importMissionState.waypoints : []
  if (!points.length) return
  const selectedInCurrent = (state.importSelectedPoints || []).filter((pt) => pt && points.includes(pt))
  if (selectedInCurrent.length === points.length) {
    fnSelectClear()
    return
  }
  fnSelectAllPoints(points)
})

$body.find('[data-leaf-add-point]').on('click', function () {
  if (state.importAddPointMode && typeof window !== 'undefined' && typeof window.PORTAL_DUMP_INSERT_PREVIEW_DEBUG === 'function') {
    window.PORTAL_DUMP_INSERT_PREVIEW_DEBUG()
  }
  const nextUnifiedMode = !state.importAddPointMode
  state.importAddPointMode = nextUnifiedMode
  state.importDragMode = nextUnifiedMode
  $(this).toggleClass('active', nextUnifiedMode)
  if (nextUnifiedMode) {
    state.importSelectMode = false
    $body.find('[data-leaf-select-square]').removeClass('active')
    $body.find('[data-leaf-select-poly]').removeClass('active')
    if (state.importSelectDrawRect) state.importSelectDrawRect.disable()
    if (state.importSelectDrawPoly) state.importSelectDrawPoly.disable()
  }
  fnSetWaypointDragging(nextUnifiedMode)
  fnSyncAddPointCursor()
})

$body.find('[data-leaf-divide-points]').on('click', function () {
  if (!state.importMissionState || !state.importMissionState.waypoints || state.importMissionState.waypoints.length < 2) {
    Swal.fire(fnT('divide.no_enough_points'))
    return
  }
  const points = state.importMissionState.waypoints
  const selectedInCurrent = (state.importSelectedPoints || []).filter((pt) => pt && points.includes(pt))
  if (!selectedInCurrent.length) {
    fnSelectAllPoints(points)
  }
  const selectedSorted = (state.importSelectedPoints || [])
    .filter((pt) => pt && points.includes(pt))
    .sort((a, b) => points.indexOf(a) - points.indexOf(b))
  if (selectedSorted.length < 2) {
    Swal.fire(fnT('divide.select_two_points'))
    return
  }
  const selectedPairs = []
  for (let i = 0; i < selectedSorted.length - 1; i++) {
    const fromPoint = selectedSorted[i]
    const toPoint = selectedSorted[i + 1]
    const fromIndex = points.indexOf(fromPoint)
    const toIndex = points.indexOf(toPoint)
    if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) continue
    const fromLatLng = L.latLng(fromPoint.latlng[0], fromPoint.latlng[1])
    const toLatLng = L.latLng(toPoint.latlng[0], toPoint.latlng[1])
    const pairDistance = map.distance(fromLatLng, toLatLng)
    if (pairDistance > 0) {
      selectedPairs.push({ fromPoint, toPoint, pairDistance })
    }
  }
  if (!selectedPairs.length) {
    Swal.fire(fnT('divide.no_valid_segment'))
    return
  }
  const maxPairDistance = _.max(selectedPairs.map(p => p.pairDistance))

  let selectedRemainderMode = 'center'
  areaSwal.fire({
    title: fnT('divide.title'),
    showCancelButton: true,
    confirmButtonText: fnT('common.ok'),
    cancelButtonText: fnT('common.cancel'),
    html: fnBuildDividePointsPopupHtml(selectedSorted.length, maxPairDistance),
    didOpen: function (modal) {
      const $modal = $(modal)
      const $distance = $modal.find('[data-divide-distance]')
      const $count = $modal.find('[data-divide-count]')
      const $heightCalcMode = $modal.find('[data-divide-height-calc-mode]')
      const $removeInserted = $modal.find('[data-divide-remove-inserted]')
      if ($heightCalcMode.length) {
        const prevMode = String($heightCalcMode.val() || 'straight')
        $heightCalcMode.empty()
        $heightCalcMode.append($('<option></option>').val('straight').text(fnT('divide.height_calc_straight')))
        fnBuildEffectiveDemProviderKeys().forEach((providerKey) => {
          if (!fnIsProviderAvailable(providerKey)) return
          const providerLabel = fnGetDemProviderLabel(providerKey)
          $heightCalcMode.append(
            $('<option></option>')
              .val(providerKey)
              .text(fnT('divide.height_calc_surface_follow_prefix') + providerLabel)
          )
        })
        if ($heightCalcMode.find('option[value="' + prevMode + '"]').length) {
          $heightCalcMode.val(prevMode)
        } else if ($heightCalcMode.find('option[value="localDEM"]').length) {
          $heightCalcMode.val('localDEM')
        } else {
          $heightCalcMode.val('straight')
        }
      }
      selectedRemainderMode = String($modal.find('[data-divide-remainder-mode]:checked').val() || 'center')
      $modal.on('change', '[data-divide-remainder-mode]', function () {
        selectedRemainderMode = String($(this).val() || 'center')
      })
      let syncLock = false
      const clampDistance = function (v) {
        if (!Number.isFinite(v) || v <= 0) return 0.1
        return v
      }
      const clampCount = function (v) {
        if (!Number.isFinite(v) || v < 1) return 1
        return Math.floor(v)
      }
      const syncCountFromDistance = function () {
        if (syncLock) return
        syncLock = true
        const d = clampDistance(parseFloat($distance.val()))
        const count = clampCount(Math.floor(maxPairDistance / d))
        $distance.val(d.toFixed(1))
        $count.val(String(count))
        syncLock = false
      }
      const syncDistanceFromCount = function () {
        if (syncLock) return
        syncLock = true
        const count = clampCount(parseInt($count.val(), 10))
        const d = maxPairDistance / count
        $count.val(String(count))
        $distance.val(d.toFixed(1))
        syncLock = false
      }
      syncCountFromDistance()
      $distance.on('input', syncCountFromDistance)
      $count.on('input', syncDistanceFromCount)
      $removeInserted.on('click', function () {
        if (!state.importMissionState || !Array.isArray(state.importMissionState.waypoints) || !state.importMissionState.waypoints.length) return
        const removable = state.importMissionState.waypoints.filter((pt) => {
          const name = fnGetPointName(pt).trim()
          return name.indexOf('P-') === 0
        })
        if (!removable.length) {
          Swal.showValidationMessage(fnT('divide.no_removable_midpoints'))
          return
        }
        const historyBefore = fnCaptureState()
        const removableSet = new Set(removable)
        removable.forEach((pt) => {
          if (pt.marker) {
            state.importLineItems.removeLayer(pt.marker)
          }
          fnRemovePointXmlNodes(pt)
        })
        state.importMissionState.waypoints = state.importMissionState.waypoints.filter((pt) => !removableSet.has(pt))
        fnSyncMissionPlacemarkOrder()
        fnRenderImportLines([state.importMissionState.lineCoords || []], state.importMissionState.waypoints, state.importKmlFilename || 'mission', state.importMissionState)
        fnHistoryPush(historyBefore)
        fnSelectClear()
        Swal.close()
      })
    },
    preConfirm: function () {
      const $popup = $(Swal.getPopup())
      const dVal = parseFloat($popup.find('[data-divide-distance]').val())
      const cVal = parseInt($popup.find('[data-divide-count]').val(), 10)
      const headingOnly = $popup.find('[data-divide-heading-only]').is(':checked')
      const headingThreshold = parseFloat($popup.find('[data-divide-heading-threshold]').val())
      const remainderMode = String(selectedRemainderMode || 'center')
      const heightCalcModeRaw = String($popup.find('[data-divide-height-calc-mode]').val() || 'straight').trim()
      const heightCalcProvider = fnIsProviderAvailable(heightCalcModeRaw) ? heightCalcModeRaw : ''
      const heightCalcMode = heightCalcProvider ? 'provider' : 'straight'
      if (!Number.isFinite(dVal) || dVal <= 0) {
        Swal.showValidationMessage(fnT('validate.distance_positive'))
        return false
      }
      if (!Number.isFinite(cVal) || cVal < 1) {
        Swal.showValidationMessage(fnT('validate.count_min_1'))
        return false
      }
      if (!Number.isFinite(headingThreshold) || headingThreshold < 0) {
        Swal.showValidationMessage(fnT('validate.threshold_min_0'))
        return false
      }
      if (!['start', 'center', 'end'].includes(remainderMode)) {
        Swal.showValidationMessage(fnT('validate.invalid_remainder_mode'))
        return false
      }
      return {
        distance: dVal,
        count: Math.floor(cVal),
        headingOnly: headingOnly,
        headingThreshold: headingThreshold,
        remainderMode: remainderMode,
        heightCalcMode: heightCalcMode,
        heightCalcProvider: heightCalcProvider
      }
    }
  }).then(async (result) => {
    if (!result.isConfirmed || !result.value) return
    const distanceBetween = Math.max(0.1, parseFloat(result.value.distance))
    const headingOnly = !!result.value.headingOnly
    const headingThreshold = Math.max(0, parseFloat(result.value.headingThreshold))
    const remainderModeRaw = String(result.value.remainderMode || 'center')
    const remainderMode = ['start', 'center', 'end'].includes(remainderModeRaw) ? remainderModeRaw : 'center'
    const heightCalcMode = String(result.value.heightCalcMode || 'straight').trim().toLowerCase() === 'provider' ? 'provider' : 'straight'
    const heightCalcProviderRaw = String(result.value.heightCalcProvider || '').trim()
    const heightCalcProviderKey = (heightCalcMode === 'provider' && fnIsProviderAvailable(heightCalcProviderRaw)) ? heightCalcProviderRaw : ''
    const useProviderHeightShift = !!heightCalcProviderKey
    const divideLoadingTask = startPortalLoadingTask({
      id: 'divide-points:' + String(Date.now()) + ':' + String(selectedPairs.length),
      title: fnT('divide.title'),
      status: fnT('divide.progress_prepare'),
      progress: 0,
      mode: 'determinate'
    })
    const fnUpdateDivideProgress = async function (progress, statusText) {
      divideLoadingTask.update({
        progress: progress,
        status: statusText,
        mode: 'determinate'
      })
      await fnYieldToUi()
    }
    const historyBefore = fnCaptureState()
    let usedLetterSteps = 0
    let usedDirectionSteps = 0
    const createdRows = []
    const pairPlans = []
    const fnGetPointRawByAliases = function (pt, aliases, xmlTags) {
      const p = (pt && pt.props && typeof pt.props === 'object') ? pt.props : {}
      for (let a = 0; a < aliases.length; a++) {
        const num = toFiniteNumber(_.get(p, aliases[a]))
        if (num !== null) return num
      }
      return fnGetFirstNumericFromPointXmlTags(pt, xmlTags)
    }
    const fnInterpolateNullable = function (startVal, endVal, t) {
      const s = Number.isFinite(Number(startVal)) ? Number(startVal) : null
      const e = Number.isFinite(Number(endVal)) ? Number(endVal) : null
      if (s !== null && e !== null) return s + ((e - s) * t)
      if (s !== null) return s
      if (e !== null) return e
      return null
    }
    const fnApplyHeightDelta = function (value, delta) {
      const base = Number.isFinite(Number(value)) ? Number(value) : null
      if (base === null) return null
      const shift = Number.isFinite(Number(delta)) ? Number(delta) : 0
      return base + shift
    }
    try {
      const planningTotal = Math.max(1, selectedPairs.length)
      for (let pairIndex = 0; pairIndex < selectedPairs.length; pairIndex++) {
        const pair = selectedPairs[pairIndex]
        const fromIndex = state.importMissionState.waypoints.indexOf(pair.fromPoint)
        const toIndex = state.importMissionState.waypoints.indexOf(pair.toPoint)
        if (fromIndex !== -1 && toIndex !== -1 && fromIndex < toIndex) {
          const first = state.importMissionState.waypoints[fromIndex]
          const second = state.importMissionState.waypoints[toIndex]
          const firstLatLng = L.latLng(first.latlng[0], first.latlng[1])
          const secondLatLng = L.latLng(second.latlng[0], second.latlng[1])
          let isEligibleByHeading = true
          if (headingOnly) {
            const heading = fnGetPointHeading(first)
            if (heading !== null) {
              const dLng = (second.latlng[1] - first.latlng[1]) * (Math.PI / 180)
              const lat1 = first.latlng[0] * (Math.PI / 180)
              const lat2 = second.latlng[0] * (Math.PI / 180)
              const y = Math.sin(dLng) * Math.cos(lat2)
              const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng)
              let bearing = Math.atan2(y, x) * (180 / Math.PI)
              bearing = (bearing + 360) % 360
              let angleDiff = Math.abs(bearing - heading) % 360
              if (angleDiff > 180) angleDiff = 360 - angleDiff
              if (angleDiff < headingThreshold) {
                isEligibleByHeading = false
              }
            }
          }
          if (isEligibleByHeading) {
            const pairDistance = map.distance(firstLatLng, secondLatLng)
            if (pairDistance > (distanceBetween * 2)) {
              const epsilon = 1e-6
              const stepCount = Math.floor((pairDistance + epsilon) / distanceBetween)
              if (stepCount >= 2) {
                const segmentLetter = fnRoundLetter(state.importDivideNameRound + usedLetterSteps)
                const isForward = (usedDirectionSteps % 2 === 0)
                const remainderDistance = Math.max(0, pairDistance - (stepCount * distanceBetween))
                const effectiveRemainderMode = (!isForward && remainderMode !== 'center')
                  ? (remainderMode === 'start' ? 'end' : 'start')
                  : remainderMode
                let edgeOffset = distanceBetween
                if (effectiveRemainderMode === 'start') {
                  edgeOffset = distanceBetween + remainderDistance
                } else if (effectiveRemainderMode === 'center') {
                  edgeOffset = distanceBetween + (remainderDistance / 2)
                }
                const segmentStart = first
                const segmentEnd = second
                const segmentStartHeightRaw = fnGetPointRawByAliases(segmentStart, POINT_HEIGHT_PATH_ALIASES, ['wpml:height', 'height'])
                const segmentEndHeightRaw = fnGetPointRawByAliases(segmentEnd, POINT_HEIGHT_PATH_ALIASES, ['wpml:height', 'height'])
                const segmentStartExecuteRaw = fnGetPointRawByAliases(segmentStart, POINT_EXECUTE_HEIGHT_PATH_ALIASES, ['wpml:executeHeight', 'executeHeight'])
                const segmentEndExecuteRaw = fnGetPointRawByAliases(segmentEnd, POINT_EXECUTE_HEIGHT_PATH_ALIASES, ['wpml:executeHeight', 'executeHeight'])
                const segmentStartProjectHeightRaw = toFiniteNumber(_.get(segmentStart, 'props.' + NON_EXPORT_POINT_HEIGHT_PATH))
                const segmentEndProjectHeightRaw = toFiniteNumber(_.get(segmentEnd, 'props.' + NON_EXPORT_POINT_HEIGHT_PATH))
                const segmentStartHeight = fnGetPointRawHeightValue(segmentStart)
                const segmentEndHeight = fnGetPointRawHeightValue(segmentEnd)
                const candidateRows = []
                const insertedCount = stepCount - 1
                for (let i = 0; i < insertedCount; i++) {
                  const dist = edgeOffset + (distanceBetween * i)
                  if (dist >= pairDistance) continue
                  const t = dist / pairDistance
                  const lat = segmentStart.latlng[0] + (segmentEnd.latlng[0] - segmentStart.latlng[0]) * t
                  const lng = segmentStart.latlng[1] + (segmentEnd.latlng[1] - segmentStart.latlng[1]) * t
                  const splitHeightRaw = fnInterpolateNullable(segmentStartHeightRaw, segmentEndHeightRaw, t)
                  const splitExecuteRaw = fnInterpolateNullable(segmentStartExecuteRaw, segmentEndExecuteRaw, t)
                  const splitProjectHeightRaw = fnInterpolateNullable(segmentStartProjectHeightRaw, segmentEndProjectHeightRaw, t)
                  let splitHeight = null
                  if (segmentStartHeight !== null && segmentEndHeight !== null) {
                    splitHeight = segmentStartHeight + ((segmentEndHeight - segmentStartHeight) * t)
                  } else if (segmentStartHeight !== null) {
                    splitHeight = segmentStartHeight
                  } else if (segmentEndHeight !== null) {
                    splitHeight = segmentEndHeight
                  }
                  candidateRows.push({
                    t: t,
                    lat: lat,
                    lng: lng,
                    splitHeightRaw: splitHeightRaw,
                    splitExecuteRaw: splitExecuteRaw,
                    splitProjectHeightRaw: splitProjectHeightRaw,
                    splitHeight: splitHeight,
                    heightDelta: 0,
                    demAt: null
                  })
                }
                if (candidateRows.length) {
                  pairPlans.push({
                    first: first,
                    second: second,
                    segmentStart: segmentStart,
                    segmentEnd: segmentEnd,
                    rows: candidateRows,
                    isForward: isForward,
                    segmentLetter: segmentLetter
                  })
                  usedLetterSteps += 1
                  usedDirectionSteps += 1
                }
              }
            }
          }
        }
        if ((pairIndex % 5) === 0 || pairIndex === selectedPairs.length - 1) {
          await fnUpdateDivideProgress(
            Math.round(((pairIndex + 1) / planningTotal) * 35),
            fnT('divide.progress_prepare') + ': ' + (pairIndex + 1) + '/' + planningTotal
          )
        }
      }
      if (!pairPlans.length) {
        divideLoadingTask.complete({
          status: fnT('common.no_change'),
          progress: 100,
          mode: 'determinate'
        })
        return
      }

      if (useProviderHeightShift) {
        const providerLabel = fnGetDemProviderLabel(heightCalcProviderKey)
        const fetchTotal = Math.max(1, pairPlans.length)
        for (let p = 0; p < pairPlans.length; p++) {
          const plan = pairPlans[p]
          await fnUpdateDivideProgress(
            35 + Math.round((p / fetchTotal) * 40),
            fnT('divide.progress_fetch_surface') + ': ' + providerLabel + ' ' + (p + 1) + '/' + fetchTotal
          )
          const samplePoints = [
            { lat: plan.segmentStart.latlng[0], lng: plan.segmentStart.latlng[1] },
            ...plan.rows.map((row) => ({ lat: row.lat, lng: row.lng })),
            { lat: plan.segmentEnd.latlng[0], lng: plan.segmentEnd.latlng[1] }
          ]
          const elevations = await fnFetchSurfaceElevationByProvider(heightCalcProviderKey, samplePoints)
          if (!Array.isArray(elevations) || elevations.length !== samplePoints.length) {
            throw new Error(fnT('dem.request_failed'))
          }
          const startDem = toFiniteNumber(elevations[0])
          const endDem = toFiniteNumber(elevations[elevations.length - 1])
          plan.rows.forEach((row, idx) => {
            const demAt = toFiniteNumber(elevations[idx + 1])
            row.demAt = demAt
            if (demAt === null || startDem === null || endDem === null) {
              row.heightDelta = 0
              return
            }
            const demLinear = startDem + ((endDem - startDem) * row.t)
            row.heightDelta = demAt - demLinear
          })
        }
      }

      const insertTotal = Math.max(1, pairPlans.length)
      for (let planIndex = 0; planIndex < pairPlans.length; planIndex++) {
        const plan = pairPlans[planIndex]
        await fnUpdateDivideProgress(
          75 + Math.round((planIndex / insertTotal) * 20),
          fnT('divide.progress_insert') + ': ' + (planIndex + 1) + '/' + insertTotal
        )
        const fromIndex = state.importMissionState.waypoints.indexOf(plan.first)
        const toIndex = state.importMissionState.waypoints.indexOf(plan.second)
        if (fromIndex === -1 || toIndex === -1 || fromIndex >= toIndex) continue
        const nameSourcePoint = plan.isForward ? plan.first : plan.second
        const insertedPoints = []
        plan.rows.forEach((row) => {
          const adjustedProjectHeight = fnApplyHeightDelta(row.splitProjectHeightRaw, row.heightDelta)
          const adjustedHeightRaw = fnApplyHeightDelta(row.splitHeightRaw, row.heightDelta)
          const adjustedExecuteRaw = fnApplyHeightDelta(row.splitExecuteRaw, row.heightDelta)
          const adjustedHeight = fnApplyHeightDelta(row.splitHeight, row.heightDelta)
          const altitudeForNewPoint = (adjustedHeightRaw !== null)
            ? adjustedHeightRaw
            : ((adjustedExecuteRaw !== null)
                ? adjustedExecuteRaw
                : ((adjustedProjectHeight !== null) ? adjustedProjectHeight : adjustedHeight))
          const newPoint = fnCreateInsertedPoint(nameSourcePoint, { lat: row.lat, lng: row.lng }, altitudeForNewPoint)
          if (!newPoint) return
          if (adjustedProjectHeight !== null) {
            fnSetByPath(newPoint.props, NON_EXPORT_POINT_HEIGHT_PATH, roundToTenth(adjustedProjectHeight))
          }
          if (adjustedHeightRaw !== null) {
            fnSetPointValueByPathAliases(newPoint, POINT_HEIGHT_PATH_ALIASES, roundToTenth(adjustedHeightRaw))
          }
          if (adjustedExecuteRaw !== null) {
            fnSetPointValueByPathAliases(newPoint, POINT_EXECUTE_HEIGHT_PATH_ALIASES, roundToTenth(adjustedExecuteRaw))
          }
          if (useProviderHeightShift && row.demAt !== null) {
            fnSetPointDemValue(newPoint, heightCalcProviderKey, roundToTenth(row.demAt))
          }
          insertedPoints.push(newPoint)
        })
        if (!insertedPoints.length) continue
        state.importMissionState.waypoints.splice(fromIndex + 1, 0, ...insertedPoints)
        createdRows.push({
          first: plan.first,
          second: plan.second,
          insertedPoints: insertedPoints,
          isForward: plan.isForward,
          segmentLetter: plan.segmentLetter
        })
      }
      if (!createdRows.length) {
        divideLoadingTask.complete({
          status: fnT('common.no_change'),
          progress: 100,
          mode: 'determinate'
        })
        return
      }
      await fnUpdateDivideProgress(98, fnT('divide.progress_finalize'))
      const renameRows = fnBuildDivideRenameRowsFromCreatedPoints(createdRows)
      fnApplyDivideRowNames(renameRows)
      state.importDivideNameRound += usedLetterSteps
      fnSyncMissionPlacemarkOrder()
      fnRenderImportLines([state.importMissionState.lineCoords || []], state.importMissionState.waypoints, state.importKmlFilename || 'mission', state.importMissionState)
      fnHistoryPush(historyBefore)
      fnSelectClear()
      divideLoadingTask.complete({
        status: fnT('divide.progress_done'),
        progress: 100,
        mode: 'determinate'
      })
    } catch (error) {
      const errText = String((error && error.message) || fnT('common.error'))
      divideLoadingTask.fail({
        status: errText
      })
      Swal.fire(fnT('common.error'), errText, 'error')
    }
  })
})

$body.find('[data-leaf-delete-selected]').on('click', function () {
  if (!state.importSelectedPoints.length) return
  if (!state.importMissionState || !state.importMissionState.waypoints) return
  const historyBefore = fnCaptureState()
  state.importSelectedPoints.forEach((pt) => {
    if (pt.marker) {
      state.importLineItems.removeLayer(pt.marker)
    }
    fnRemovePointXmlNodes(pt)
  })
  state.importMissionState.waypoints = state.importMissionState.waypoints.filter(p => !state.importSelectedPoints.includes(p))
  fnSyncMissionPlacemarkOrder()
  fnRenderImportLines([state.importMissionState.lineCoords || []], state.importMissionState.waypoints, state.importKmlFilename || 'mission', state.importMissionState)
  fnHistoryPush(historyBefore)
  fnSelectClear()
})

$body.find('[data-leaf-edit-selected]').on('click', function () {
  if (!state.importMissionState || !state.importMissionState.waypoints || !state.importMissionState.waypoints.length) return
  const points = state.importMissionState.waypoints
  const selectedInCurrent = (state.importSelectedPoints || []).filter((pt) => pt && points.includes(pt))
  if (!selectedInCurrent.length) {
    fnSelectAllPoints(points)
  }
  if (!state.importSelectedPoints.length) return
  fnSwalBulkEdit(state.importSelectedPoints)
})


}

export {
  bindWaypointToolsHandlers
}
